<footer class="color-surface-container-subtle {{customClass}}">
  <div class="footer-container">
    @if (isAuthenticated()) {
      <div class="flex flex-col-reverse md:flex-row gap-8 items-start py-10">
        <div class="flex flex-col gap-2 items-start max-w-150 min-w-85">
          <img src="assets/img/Intrafi_footer_logo_blue.svg" alt="IntraFi Blue Logo" class="h-6"/>
          <p class="dcp-body-small dark-gray-color mb-0! flex items-center flex-wrap gap-1" i18n="@@footer.copyright">
            &copy; {{ currentDate | date: 'yyyy' }} IntraFi Network, LLC |
            <pin-button id="privacy-policy" buttonStyle="link" [redirectUrl]="privacyPolicyRoute">
              Privacy Policy
            </pin-button>
          </p>
          <p class="dcp-body-small gray-color-variant mb-0!" i18n="@@footer.legal">
            IntraFi<sup>®</sup>, the IntraFi logo, ICS<sup>®</sup>, and CDARS<sup>®</sup> are registered service marks of IntraFi LLC.
          </p>
        </div>
      @if (footerLogoAndCopyrightIsDisplayed()) {
        <div class="max-w-150">
          <pin-bank-footer-logo [bankCustomizationData]="bankCustomizationData"></pin-bank-footer-logo>
        </div>
      }
      </div>
    } @else {
      <div class="flex flex-col gap-2 items-center justify-center px-17 py-10 dark-gray-color">
        <p class="dcp-body-small dark-gray-color mb-0! flex items-center gap-1" i18n="@@footer.copyright">
          &copy; {{ currentDate | date: 'yyyy' }} IntraFi Network, LLC |
          <pin-button id="privacy-policy" buttonStyle="link" [redirectUrl]="privacyPolicyRoute">
            Privacy Policy
          </pin-button>
        </p>
         <p class="dcp-body-small gray-color-variant mb-0! text-center" i18n="@@footer.legal">
           IntraFi<sup>®</sup>, the IntraFi logo, ICS<sup>®</sup>, and CDARS<sup>®</sup> are registered service marks of IntraFi LLC.
         </p>
      </div>
    }
  </div>
</footer>
